import { useQuery } from "react-query";
import { DashboardInadimplentesResponse } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";
import { RelatorioInadimplentesQueryParams } from "../typings/index";

function useRelatorioInadimplentesDashboard(
  query: RelatorioInadimplentesQueryParams
) {
  return useQuery<DashboardInadimplentesResponse, AxiosError>(
    [`/v1/relatorios/financeiro/inadimplentes/dashboard`, query],
    async () => {
      const { data } = await http.get<DashboardInadimplentesResponse>(
        "/v1/relatorios/financeiro/inadimplentes/dashboard",
        {
          params: query,
        }
      );

      return data;
    }
  );
}

export default useRelatorioInadimplentesDashboard;
